import React, { useCallback, useState } from 'react';
import { Box, Flex } from 'rebass';
import Logo from './Logo';
import NavLink, { NavLinkItem } from './NavLink';
import UserLink from './UserLink';
import useSessionInfo from '../../hooks/useSessionInfo';
import useMode from '../../hooks/useMode';
import { useHistory } from 'react-router-dom';
import IconLink from '../Icon/IconLink';
import UserMenu from './UserMenu';
import { UserMode } from '../../hooks/useApolloClient';
import { isImpersonating } from '../../services/auth';

export const navigationLinks = (mode: UserMode): NavLinkItem[] =>
  ({
    'water-supplier': [
      { text: 'Dashboard', href: '' },
      { text: 'Reports', href: '/test-reports' },
      { text: 'Backflow Tests', href: '/jobs' },
      { text: 'Assemblies', href: '/assemblies' },
      { text: 'Services', href: '/water-services' },
      // { text: 'Sites', href: '/water-sites' },
      // { text: 'Hazard Surveys', href: '/hazard-surveys' },
      // { text: 'Hazards', href: '/water-hazards' },
      // { text: 'Survey Templates', href: '/survey-templates' },
      { text: 'Customers', href: '/customers' },
      { text: 'Testers', href: '/testers' },
      { text: 'Notices', href: '/notices' },
    ],
    company: [
      { text: 'Backflow Tests', href: '/jobs' },
      { text: 'Assemblies', href: '/assemblies' },
      { text: 'Customers', href: '/customers' },
      { text: 'Testers', href: '/testers' },
      ...(isImpersonating() ? [{ text: 'Notices', href: '/notices' }] : []),
    ],
    admin: [
      { text: 'Dashboard', href: '' },
      { text: 'Companies', href: '/companies' },
      { text: 'Water Suppliers', href: '/water-suppliers' },
      { text: 'Users', href: '/users' },
      { text: 'Makes & Models', href: '/makes' },
      { text: 'Plans', href: '/plans' },
      // { text: 'Water Hazards', href: '/water-hazards' },
      // { text: 'Survey Templates', href: '/survey-templates' },
    ],
    individual: [
      { text: 'Backflow Tests', href: '/jobs' },
      { text: 'Profile', href: '/profile' },
    ],
  })[mode];

const Header = (): JSX.Element => {
  const { me } = useSessionInfo();
  const mode = useMode();
  const navLinks = navigationLinks(mode);
  const [navOpen, setNavOpen] = useState(false);
  const toggleNav = useCallback(() => {
    setNavOpen(!navOpen);
  }, [setNavOpen, navOpen]);
  const history = useHistory();
  return (
    <Box width="100%" height={50}>
      <Flex
        px={3}
        bg="navbar"
        as="header"
        sx={{
          whiteSpace: 'nowrap',
          zIndex: [navOpen ? 20 : 10, navOpen ? 20 : 10, 10],
          position: [
            navOpen ? 'absolute' : 'relative',
            navOpen ? 'absolute' : 'relative',
            'relative',
          ],
          top: 0,
          left: 0,
          right: 0,

          // boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          boxShadow: '0px 4px 6px 0px #0000001A',

          flexDirection: [
            navOpen ? 'column' : 'row',
            navOpen ? 'column' : 'row',
            'row',
          ],
        }}
      >
        <Logo padding={3} onClick={() => history.push(`/`)} />
        <IconLink
          icon="list"
          iconSize={6}
          iconAtEnd
          isDark
          alignSelf="flex-end"
          onClick={toggleNav}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            flexGrow: 0,
            flexShrink: 0,
            display: ['block', 'block', 'none'],
          }}
        />
        <Box
          as="menu"
          sx={{
            padding: 0,
            alignItems: 'center',
            justifyContent: 'space-between',
            flexGrow: 1,
            display: [
              navOpen ? 'block' : 'none',
              navOpen ? 'block' : 'none',
              'flex',
            ],
            flexDirection: ['column', 'column', 'row'],
          }}
        >
          {navLinks && (
            <>
              <Flex
                as="nav"
                flexShrink={0}
                sx={{ flexDirection: ['column', 'column', 'row'] }}
              >
                {navLinks.map((link, i) => (
                  <NavLink
                    exact={!link.href}
                    key={i}
                    to={mode ? `/${mode}${link.href}` : link.href}
                  >
                    {link.text}
                  </NavLink>
                ))}
              </Flex>
            </>
          )}
          {navOpen && me && <UserMenu />}
          {!navOpen && me && (
            <UserLink sx={{ flexShrink: 0, justifySelf: 'flex-end' }}>
              {me.name}
            </UserLink>
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default Header;
